export default {
  'introThanks': 'Grazie per il vostro feedback, è un aiuto a migliorarci!',
  'customerFirstname': 'Nome',
  'customerLastname': 'Cognome',
  'customerEmail': 'e-mail',
  'customerTitle': 'Titolo',
  'visitFrom': 'Data di arrivo',
  'visitTo': 'Data di partenza',
  'visitRoom': 'Numero della camera',
  'salutationOptionMr': 'Signor',
  'salutationOptionMrs': 'Signora',
  'salutationOptionFamily': 'Famiglia',
  'btnStart': 'Inizio',
  'thanksTitle': 'Grazie!',
  'thanksTextFinish': 'Coloro che hanno fretta possono compilare il questionario ora ...',
  'thanksBtnFinish': 'Chiudi',
  'thanksTextContinue': '...ma se avete ancora qualche minuto di tempo, vorremmo farvi alcune domande più dettagliate',
  'thanksBtnContinue': 'Ulteriori domande',
  'selectChooseOption': 'Per cortesia, scegliete un\'opzione',
  'btnNext': 'Continua',
  'btnSkip': 'Salta',
  'btnFeedback': 'Commento',
  'selectorTextThanks': 'Grazie per il vostro aiuto!',
  'selectorTextSelect': 'Di quale offerta avete usufruito?',
  'feedbackTitle': 'Il vostro commento su questo argomento',
  'feedbackPositiveTitle': 'Cosa è stato positivo?',
  'feedbackNegativeTitle': 'Cosa è stato negativo?',
  'smileyVeryHappy': 'Molto soddisfatto',
  'smileyHappy': 'Soddisfatto',
  'smileyMedium': 'Nella media',
  'smileyUnhappy': 'Insoddisfatto',
  'smileyVeryUnhappy': 'Molto insoddisfatto',
  'smileyNotScored': 'Non valutato',
  'validationMessageEmail': 'Per cortesia, inserire un indirizzo e-mail valido',
  'validationMessageRequired': '"Campi obbligatori"',
  'txtAppStart': 'Carica il questionario...',
  'selectorTitle': 'Utilizzo delle nostre offerte',
  'finalThanksTitle': 'Grazie per i vostri suggerimanti',
  'finalThanksHolidayCheckIntro': 'Possiamo trasmettere parte della vostra valutazione a HolidayCheck?<br />Ci sarebbe di grande aiuto! Nella pagina seguente mostriamo un riepilogo dei vostri dati che noi, con il vostro consenso, trasferiremo a HolidayCheck.<br /><br />Si tratta di pochi click & integrazioni - e abbiamo finito...',
  'finalThanksHolidayCheckBtn': 'Mostra il riepilogo di HolidayCheck',
  'pickDate': 'Scegliete una data',
  'surveyFinishedTitle': 'Il questionario è terminato',
  'surveyAlreadyDone': 'Hai già partecipato a questo sondaggio, grazie!',
  'legendPrimerPositive': 'Completamente soddisfatto',
  'legendPrimerNegative': 'Molto insoddisfatto',
  'hcTitle_recommendation': 'Raccomandereste questo hotel?',
  'hcTitle_title': 'Qual è il titolo della vostra valutazione?',
  'hcTitle_text': 'Descrivete l\'hotel in generale',
  'hcDescription_text': 'Descrivete la vostra prima impressione dell\'hotel in 2-3 frasi. Era adatto, ad esempio, per il motivo del vostro viaggio?',
  'hcFilledHint': 'Per cortesia, compilare tutti i campi',
  'hcTitle_age': 'Quanti anni ha?',
  'hcTitle_traveledWith': 'Con chi ha viaggiato?',
  'hcTitle_travelDuration': 'Durata del soggiorno',
  'hcOption_traveledWith_friends': 'Amici',
  'hcOption_traveledWith_family': 'Famiglia',
  'hcOption_traveledWith_couple': 'Coppia',
  'hcOption_traveledWith_single': 'Da solo',
  'hcOption_children_no': 'Nessuno',
  'hcOption_children_one': '1',
  'hcOption_children_two': '2',
  'hcOption_children_three': '3',
  'hcOption_children_four': '4',
  'hcOption_children_more': 'più di 4',
  'hcOption_age_14-18': '16 - 18',
  'hcOption_age_19-25': '19 - 25',
  'hcOption_age_26-30': '26 - 30',
  'hcOption_age_31-35': '31 - 35',
  'hcOption_age_36-40': '36 - 40',
  'hcOption_age_41-45': '41 - 45',
  'hcOption_age_46-50': '46 - 50',
  'hcOption_age_51-55': '51 - 55',
  'hcOption_age_56-60': '56 - 60',
  'hcOption_age_61-65': '61 - 65',
  'hcOption_age_66-70': '66 - 70',
  'hcOption_age_70 >': '70+',
  'hcOption_ratingCostPerformance_poor': 'Molto male',
  'hcOption_ratingCostPerformance_bad': 'Piuttosto male',
  'hcOption_ratingCostPerformance_medium': 'Adeguato',
  'hcOption_ratingCostPerformance_good': 'Bene',
  'hcOption_ratingCostPerformance_great': 'Molto bene',
  'hcOption_travelReason_business': 'Lavoro',
  'hcOption_travelReason_city': 'Cittá',
  'hcOption_travelReason_wellness': 'Benessere',
  'hcOption_travelReason_winter': 'Inverno',
  'hcOption_travelReason_other': 'Altro',
  'hcOption_travelReason_beach': 'Spiaggia',
  'hcOption_travelDuration_1-3 days': '1-3 giorni',
  'hcOption_travelDuration_3-5 days': '3-5 giorni',
  'hcOption_travelDuration_1 week': '1 settimana',
  'hcOption_travelDuration_2 weeks': '2 settimane',
  'hcOption_travelDuration_3 weeks': 'Più di 2 settimane',
  'hcCardTitle': 'Trasferimento della valutazione di Holidaycheck',
  'hcPrivacyHint': 'Die Informationen zum Datenschutz gemäß Art. 13 und 14 DSGVO finden Sie hier <a href="https://www.holidaycheck.de/datenschutz" target="_blank">Link zum Datenschutz von HolidayCheck</a>.',
  'hcConsentHint': ' Ich erkläre mich damit einverstanden, dass meine angegebenen persönlichen Daten sowie die Bewertung zu HolidayCheck übertragen und veröffentlicht wird und akzeptiere die <a  target="_blank" href="https://www.holidaycheck.de/nutzungsbedingungen">Nutzungsbedingungen</a> von HolidayCheck',
  'btnSubmit': 'Inviare',
  'requiredField': 'Campi obbligatori',
  'topicTitle': 'Un altro argomento?',
  'topicHint': 'Selezionare l\'argomento per il quale si desidera lasciare un commento',
  'txtSuggestFeedback': 'Avere un suo commento sarebbe fantastico :-)',
  'txtFiguresPercent': 'Dati in percentuale',
  'txtImpress': 'Nota legale',
  'linkImpress': 'https://www.vioma.de/de/service/impressum/',
  'txtPrivacy': 'Informativa sulla privacy',
  'txtPrivacyConsent': 'Acconsento che i miei dati in questo sondaggio possano essere raccolti ed elaborati al fine di migliorarne la qualità. I dati verranno cancellati 24 mesi dopo il sondaggio. È possibile revocare il consenso in qualsiasi momento al seguente indirizzo e-mail <a href="mailto:%{mail}">%{mail}</a>. Troverete informazioni dettagliate sul trattamento dei dati degli utenti nel nostro <a href="%{link}" target="_blank">Informazioni sulla privacy</a>.',
  'txtPrivacyHint': 'Accetto che il mio parere sia pubblicato sul sito web della società e sulla pagina di recensioni <a href="%{link}" target="_blank">%{link}</a> con il mio sesso, il nome abbreviato, la città e la data di presentazione del commento. Posso revocare questo consenso in qualsiasi momento all\'indirizzo <a href="mailto:%{mail}">%{mail}</a> I commenti pubblicati verranno quindi cancellati.',
  'txtExample': 'Esempio',
  'txtSkip': 'Passa oltre',
  'txtPrivacyValidationHint': 'Non possiamo elaborare il testo senza autorizzazione.',
  'btnDifferentTopic': 'Altro argomento'
}



// WEBPACK FOOTER //
// ./src/languages/it.js